<template>
  <div>
    <a-alert type="success" :showIcon="showIcon">
      <a-icon type="credit-card" slot="icon" style="fontSize:20px;" />
      <div slot="message" style="margin: 4px;">
        <h3>Your minimal monthly commitment is: {{minimalPaygPrice}} US$</h3>
      </div>
      <div slot="description" style="font-size: 1.1em; margin: 4px;">
        <p v-if="showCurrent">
            <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
            Reported Monthly Active Users: <b>{{currentMAU}}</b> (Real-time usage data)
        </p>
        <p>
          <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          Included Monthly Active Users: {{minimalMAU}}
        </p>
        <p>
          <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          Additonal Monthly Active Users: {{additionalMau}}
        </p>
        <p v-if="!showCurrent">
          <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          Total Monthly Active Users: {{initialMAU}}
        </p>
        <a-slider
          v-if="showCurrent"
          v-model="tieredInitialMau"
          :min="1000"
          :max="51000"
          :step="stepSize"
          style="padding:5px;"
          :marks="marks"
          :disabled="disabled"
        />
        <a-slider
          v-else
          v-model="initialMAU"
          :min="0"
          :max="50000"
          :step="stepSize"
          style="padding:5px;"
          :marks="marks"
          :disabled="disabled"
        />
        <h3 style="margin-top:2.5em;">Your projected total monthly cost is: {{paygPrice}} US$</h3>
      </div>
    </a-alert>
  </div>
</template>

<script>
export default {
  data() {
    return {
      minimalMAU: 2000,
      minimalCharge: 20,
      perStepPrice: 20,
      stepSize: 2000,
      initialMAU: this.currentMAU,
      size: "large",
      marks: {
        0: "0",
        10000: "10000",
        20000: "20000",
        30000: "30000",
        40000: "40000",
        50000: "50000"
      }
    };
  },
  props: {
    currentMAU: {
      type: Number,
      default: 2000
    },
    showCurrent: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    showIcon: {
        type: Boolean,
        default: true
    }
  },

  computed: {
    paygPrice() {
      if (this.initialMAU <= this.minimalMAU) {
        return this.minimalCharge;
      }
      else {
        return this.minimalCharge+(Math.ceil(this.additionalMau/this.stepSize) * this.perStepPrice)
      }
    },
    minimalPaygPrice() {
      return this.minimalMAU * 0.01;
    },
    tieredInitialMau() {
      if (this.initialMAU <= this.minimalMAU) {
        return this.minimalMAU;
      }
      else {
        return this.minimalMAU+(Math.ceil(this.additionalMau/this.stepSize) * this.stepSize)
      }
    },
    additionalMau() {
      return this.initialMAU > this.minimalMAU
        ? this.initialMAU - this.minimalMAU
        : 0;
    }
  }
};
</script>